import { FileText, House, PuzzlePiece, SignOut, User } from 'phosphor-react';
import React, { useState } from 'react';
import { BsHouse, BsPuzzle } from 'react-icons/bs';
import { HiOutlineDocumentReport } from 'react-icons/hi';
import { useHistory } from 'react-router-dom';
import { Menu } from 'semantic-ui-react';
import packageInfo from '../../../package.json';

import logoEthosx from '../../assets/images/logo.png';
import { styleSheet } from '../../assets/styles/global';
import EditUserProfile from '../EditUserProfile';

import {
  SideMenuContainer, SideMenuList, SideMenuListItem, MenuListText,
  MainLogo,
  VersionText,
  VersionContainer,
} from './styles';

interface Props {
  currentMenu: string;
}

const SideMenu: React.FC<Props> = ({ currentMenu }) => {
  const [editUserProfileModal, setEditUserProfileModal] = useState(false)

  const history = useHistory()

  const handleLogout = async () => {
    await localStorage.removeItem('ethosxAnalista:token')
    await sessionStorage.removeItem('analystName')
    await sessionStorage.removeItem('token')

    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach(name => {
          caches.delete(name);
        })
      });
    }

    history.push('/login')
    window.location.reload();

  }

  return (
    <SideMenuContainer>
      <MainLogo src={logoEthosx} />

      <Menu 
        vertical  compact icon="labeled"  size='massive' inverted
        pointing style={{ backgroundColor: styleSheet.bgDark }}
      >
        <Menu.Item
          name='Calendário'
          active={!editUserProfileModal && currentMenu === 'calendario'}
          onClick={() => history.push('/schedule')}
          icon={<House size={25} weight="thin" />}
          style={{ display: 'flex', alignItems: 'center' }}
        />

        <Menu.Item
          name='Skills'
          active={!editUserProfileModal && currentMenu === 'skills'}
          onClick={() => history.push('/skills')}
          icon={<PuzzlePiece size={25} weight="thin" />}
          style={{ display: 'flex', alignItems: 'center' }}
        />
        <Menu.Item
          name='Relatório'
          active={!editUserProfileModal && currentMenu === 'report'}
          onClick={() => history.push('/report')}
          icon={<FileText size={25} weight="thin" />}
          header
        />


        <Menu.Item
          name='Perfil'
          active={editUserProfileModal}
          onClick={() => setEditUserProfileModal(true)}
          icon={<User size={25} weight="thin" />}
          style={{ display: 'flex', alignItems: 'center' }}
        />

        <Menu.Item
          name='Sair'
          active={currentMenu === 'logout'}
          onClick={handleLogout}
          icon={<SignOut size={25} weight="thin" />}
          style={{ display: 'flex', alignItems: 'center' }}
        />

      </Menu>
      {/* <SideMenuList>
        <SideMenuListItem to="/schedule">
          <BsHouse color={currentMenu === 'calendario' ? styleSheet.colorMain : styleSheet.shapeDark} size={24} />
          <MenuListText style={{ color: currentMenu === 'calendario' ? styleSheet.colorMain : styleSheet.shapeDark }} >Calendario</MenuListText>
        </SideMenuListItem>

        <SideMenuListItem to="/skills">
          <BsPuzzle color={currentMenu === 'skills' ? styleSheet.colorMain : styleSheet.shapeDark} size={24} />
          <MenuListText style={{ color: currentMenu === 'skills' ? styleSheet.colorMain : styleSheet.shapeDark }} >Skills</MenuListText>
        </SideMenuListItem>

        <SideMenuListItem to="/report">
          <HiOutlineDocumentReport color={currentMenu === 'report' ? styleSheet.colorMain : styleSheet.shapeDark} size={24} />
          <MenuListText style={{ color: currentMenu === 'report' ? styleSheet.colorMain : styleSheet.shapeDark }} >Relatório</MenuListText>
        </SideMenuListItem>

      </SideMenuList> */}

      <div></div>
      <VersionContainer>
        <VersionText>v{packageInfo.version}</VersionText>
      </VersionContainer>

      {
        editUserProfileModal && (
          <EditUserProfile visible={editUserProfileModal} closeModal={() => setEditUserProfileModal(false)} />
        )
      }
    </SideMenuContainer>
  );
}

export default SideMenu;